import $ from 'init/jquery'
import includes from 'lodash/includes'
import toArray from 'lodash/toArray'
import findIndex from 'lodash/findIndex'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import Backbone from 'init/backbone'
import values from 'lodash/values'
import keys from 'lodash/keys'
import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { CartItem } from 'es6/models/cart-item'
import { Model } from 'es6/components/model'
import { KEY_CODES, SEARCH_RECOMENDATIONS_LOAD_LATENCY } from 'es6/constants'
import { abSegment } from 'init/ab-segment'
import { activeSearchFilterState } from 'init/active-filter-search-state'
import { okoPush } from 'helpers/oko-helpers'

/**
 * Вид для отправки событий в ОКО.
 * @param {Object} options Опции.
 * @param {Wish} options.wish Коллекция избранных товаров.
 * @param {Category} [options.category] Коллекция товаров в категории.
 * @param {Search} [options.search] Коллекция товаров на странице поиска.
 * @param {WishItems} [options.wishItems] Коллекция избранных товаров на странице избранного.
 * @param {Router} [options.searchRouter] Роутер на странице поиска.
 * @param {Router} [options.categoryRouter] Роутер в категории.
 */
@Defaults({
  // флаг инициализации (открытие страницы с первоначальными данными)
  catalogInitFlag: true,
  // флаг изменения параметров поиска
  catalogParamsFlag: false,
  // список просмотренных пользователем товаров
  viewedItemList: [],
  lastQuery: '',
  additionalOptions: [
    'wish',
    'category',
    'categoryRouter',
    'search',
    'searchRouter',
    'wishItems',
    'wishRouter',
  ],
})
export class OkoEvents extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.eventApplySort = this.eventApplySort.bind(this)
    this.eventPerPage = this.eventPerPage.bind(this)
    this.eventApplyViewtype = this.eventApplyViewtype.bind(this)
    // избранное
    this.listenTo(this.wish, 'add', this.eventAddToWish)
    this.listenTo(Backbone, 'add-all-to-wish', this.eventAddAllToWish)
    this.listenTo(this.wish, 'remove', this.eventRemoveFromWish)
    // корзина
    this.listenTo(Backbone, 'changeQtyForOko', this.eventCart)
    this.listenTo(Backbone, 'remove-all-from-cart', this.eventRemoveAllFromCart)

    // скрытие рекомендованного товара
    this.listenTo(Backbone, 'recommendationsItem:hideItem', this.pushHideRecommendation)

    this.listenTo(Backbone, 'apply-sort', this.eventApplySort)
    this.listenTo(Backbone, 'apply-viewtype', this.eventApplyViewtype)

    this.listenTo(Backbone, 'upsale-item', this.eventUpsaleItem)

    const $pagination = $('.b-pagination')
    // переход на страницу в пагинации
    $pagination.on('click', 'span', e => {
      if ($(e.currentTarget).text() !== '...') {
        this.pushData({
          n: 'page',
          value: $(e.currentTarget).data('page'),
        })
      }
    })
    $pagination.on('click', '.js-page-select-submit', () => {
      this.pushData({
        n: 'page',
        value: parseInt($('.js-select-page-input').val(), 10),
      })
    })
    $pagination.on('keypress', '.js-select-page-input', e => {
      if (e.keyCode === KEY_CODES.Enter) {
        this.pushData({
          n: 'page',
          value: parseInt($('.js-select-page-input').val(), 10),
        })
      }
    })
    // смена сортировки
    $('.catalog-sort').first().on('click', '.js-sort', this.eventApplySort)
    // изменение кол-ва на странице
    $('.catalog-show').on('click', '.js-page-size-value', this.eventPerPage)

    // категория: параметры фильтрации
    const catalogWithEvents = this.category || this.search || this.wishItems,
      catalogRouterWithEvents = this.categoryRouter || this.searchRouter || this.wishRouter
    if (catalogWithEvents) {
      this.listenTo(catalogWithEvents, 'sync', this.eventCatalog)
      this.listenTo(catalogWithEvents, 'change:is_viewed', this.eventViewItem)
      // при запросе фильтров без моделей роутер не работает.
      this.listenTo(catalogRouterWithEvents, 'change-filter', this.eventCatalogParams)
      this.listenTo(catalogRouterWithEvents, 'change-get-params', this.handleRouterEvents)
    }
    if (this.cart) {
      this.listenTo(this.cart, 'change:is_viewed', this.eventViewItem)
    }
    // раз в N секунд отправляем в OKO список просмотренных пользователем товаров
    setInterval(() => {
      if (!this.viewedItemList.length) {
        return
      }

      const sidList = this.viewedItemList
      this.viewedItemList = []

      let result = sidList.reduce((a, current) => {
        a = Array.isArray(a) ? a : [a]

        if (a.indexOf(current) >= 0) {
          if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
            Raven.captureException(new Error('Duplicated item: ' + current))
          }
        } else {
          a.push(current)
        }

        return a
      })

      result = Array.isArray(result) ? result : [result]
      this.pushData({
        n: 'item-view',
        sid: result,
      })
    }, 1000)
  }

  /**
   * Обработка смены отображения количества товаров на странице.
   * @param {jQuery.Event} e Событие.
   */
  eventPerPage (e) {
    const { dataset } = e.currentTarget
    if (!isEmpty(dataset)) {
      this.pushData({
        n: 'per-page',
        value: dataset.mode === 'infinite' ? 0 : parseInt(dataset.pagesize, 10),
      })
    }
  }

  /**
   * Обработка события применения сортировки.
   * @param {jQuery.Event} e jQuery Событие.
   */
  eventApplySort (e) {
    this.pushData({
      n: 'sort',
      value: $(e.currentTarget).data('sort'),
    })
  }

  /**
   * Обработка события изменения вида отображения.
   * @param {jQuery.Event} e jQuery Событие клике по кнопке смены вида.
   */
  eventApplyViewtype (e) {
    this.pushData({
      n: 'view-type',
      value: $(e.currentTarget).data('viewtype'),
    })
  }

  /**
   * Обработка события изменения параметров роутера.
   *
   * @param {Array} paramKeys
   */
  handleRouterEvents (paramKeys) {
    const hasChangedFiltersOrQuery = paramKeys.filter(param => {
      return includes(['f', 'q'], param)
    })
    if (hasChangedFiltersOrQuery.length) {
      this.eventCatalogParams()
    }
  }

  /**
   * Получение позиции добавленного в корзину товара на странице каталога/поиска
   * @param {Object} model
   * @returns {number}
   */
  getAddedItemPosition (model) {
    let withPages,
      position = 0,
      collection = this.category || this.search,
      models,
      state,
      mode
    if (collection) {
      models = toArray(collection.models)
      state = collection.state
      mode = collection.mode
      withPages = mode === 'infinite' ? 0 : (state.currentPage - 1) * state.pageSize
      position = 1 + findIndex(models, item => {
        return item.id === model.item_id
      })
      position = position + withPages
    }
    return position
  }

  /**
   * Событие удаление всех товаров из корзины.
   */
  eventRemoveAllFromCart () {
    this.pushData({
      n: 'clear-cart',
    })
  }

  /**
   * События корзины
   *
   * @param {string} type
   * @param {Object} model
   * @param {Object} prevModel
   * @param {boolean} isInRecommendationsBlock
   */
  eventCart (type, model, prevModel, isInRecommendationsBlock) {
    switch (type) {
      case 'add':
        this.eventAddCartProduct(model, isInRecommendationsBlock)
        break
      case 'remove':
        this.eventRemoveCartProduct(model)
        break
      case 'change':
        this.eventChangeCartProductQty(model, prevModel, isInRecommendationsBlock)
    }
  }

  /**
   * События с блока "Выгодное предложение" в корзине
   * @param {string} type тип события
   * @param {number} [itemSid] артикул товара
   */
  eventUpsaleItem (type, itemSid) {
    switch (type) {
      case ('show'):
        this.eventShowUpsaleCart()
        break
      case ('add'):
        this.eventUpsaleItemAddedToCart(itemSid)
        break
      case ('click'):
        this.eventClickOnUpsaleCartItem(itemSid)
        break
      default:
        throw new Error('Некорректные данные')
    }
  }

  /**
   * Отправка данных о показе блока "Выгодное предложение" в корзине
   */
  eventShowUpsaleCart () {
    this.pushData({
      n: 'rs-view',
      algo: 'os_recommend',
    })
  }

  /**
   * Отправка данных при клике на товар из блока "Выгодное предложение" в корзине
   * @param {number} itemSid SID-идентификатор товара.
   */
  eventClickOnUpsaleCartItem (itemSid) {
    this.pushData({
      n: 'rs-click',
      algo: 'os_recommend',
      sid: itemSid,
    })
  }

  /**
   * Отправка данных при добавлении товара из блока "Выгодное предложение" в корзину
   * @param {number} itemSid SID-идентификатор товара.
   */
  eventUpsaleItemAddedToCart (itemSid) {
    this.pushData({
      n: 'rs-add',
      algo: 'os_recommend',
      sid: itemSid,
    })
  }

  /**
   * Добавление товара в избранное.
   *
   * @param {CartItem} model
   */
  eventAddToWish (model) {
    this.pushData({
      n: 'add-to-wishlist',
      sid: model.get('item_sid'),
    })
  }

  /**
   * Добавление товаров в избранное.
   * @param {Array<number>} sids Массив из sid-ов товаров, добавленных в избранное.
   */
  eventAddAllToWish (sids) {
    this.pushData({
      n: 'all-to-wishlist',
      sids,
    })
  }

  /**
   * Удаление товара из избранного.
   *
   * @param {CartItem} model
   */
  eventRemoveFromWish (model) {
    this.pushData({
      n: 'del-from-wishlist',
      sid: model.get('item_sid'),
    })
  }

  /**
   * Отправка данных при клике по кнопке 'Не интересно'/'Отменить' у рекомендованного товара
   * @param {Object} data Данные о товаре, который стал не интересен
   */
  pushHideRecommendation (data) {
    this.pushData({
      n: 'rs-not-int',
      algo: data.algo,
      sid: data.sid,
      type_id: data.type,
    })
  }

  /**
   * Добавление товара в корзину.
   *
   * @param {Object} model Объект данных модели товара.
   * @param {boolean} isInRecommendationsBlock Признак события вызываемого с блока рекомендацией.
   */
  eventAddCartProduct (model, isInRecommendationsBlock) {
    Backbone.trigger('vk-cart-event', model, true)
    const okoData = {
        n: 'add-to-cart',
        sid: model.item_sid,
        q: model.qty,
        price: model.price,
      },
      position = this.getAddedItemPosition(model)
    if (position && !isInRecommendationsBlock) {
      okoData.position = position
    }
    this.pushData(okoData)
  }

  /**
   * Удаление товара из корзины.
   *
   * @param {Object} model Объект данных модели товара.
   */
  eventRemoveCartProduct (model) {
    Backbone.trigger('vk-cart-event', model, false)
    if (model.qty === null) {
      if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
        Raven.captureException(
          new Error('Параметр q имеет значение null при отправке в Oko события "del-from-cart"')
        )
      }
    }
    this.pushData({
      n: 'del-from-cart',
      sid: model.item_sid,
      q: model.qty,
    })
  }

  /**
   * Изменение кол-ва товара в корзины.
   *
   * @param {Object} model
   * @param {Object} prevModel
   * @param {boolean} isInRecommendationsBlock
   */
  eventChangeCartProductQty (model, prevModel, isInRecommendationsBlock) {
    const qtyDelta = parseInt(model.qty, 10) - parseInt(prevModel.qty, 10),
      sendData = {
        qty: Math.abs(qtyDelta),
        item_sid: model.item_sid,
        price: model.price,
        item_id: model.item_id,
        price_max: model.price_max,
        has_discount: model.item instanceof Model
          ? model.item.get('has_discount')
          : get(model, 'item.has_discount', 0),
      }
    if (!qtyDelta) {
      return
    }

    if (qtyDelta > 0) {
      // увеличили
      this.eventAddCartProduct(sendData, isInRecommendationsBlock)
    } else {
      // уменьшили
      this.eventRemoveCartProduct(sendData)
    }
  }

  /**
   * Реакция на изменение параметров поиска в каталоге/поиске
   *
   * @param {Search|Category} collection Коллекция товаров.
   */
  eventCatalog (collection) {
    if (this.search && collection.fetchCounter === 2) {
      // если мы в поиске отправляем событие фильтрации при инициализации.
      this.catalogInitFlag = false
      this.catalogParamsFlag = true
    }
    if (this.catalogInitFlag || !this.catalogParamsFlag) {
      this.catalogInitFlag = false
      this.catalogParamsFlag = false
      return
    }

    let filter
    try {
      filter = JSON.parse(collection.filter) || {}
    } catch (e) {
      filter = {}
    }
    // для поиска по строке отправляем ту строку, по которой в конечном итоге был осуществлён поиск
    if (this.search) {
      let raw_q,
        hasSuggestions = collection.suggest.get('word') && collection.suggest.get('word').length
      filter.q = raw_q = collection.query

      if (collection.translit) {
        filter.q = collection.translit
      }
      if (collection.categoryQuery) {
        filter.qc = collection.categoryQuery
      }

      if (collection.suggest.get('word') && collection.suggest.get('word').length) {
        // очищаем от HTML-тэгов
        filter.q = $('<div>' + collection.suggest.get('word') + '</div>').text()
      }
      if (collection.translit || hasSuggestions) {
        filter.raw_q = raw_q
      }
      let query = filter.q
      // показываем сегменту С исходный запрос
      if (abSegment === 'C') {
        query = collection.query
      }
      if (this.lastQuery !== query) {
        const timeStamp = Math.round(Date.now() / 1000)
        this.lastQuery = query
        setTimeout(() => {
          Backbone.trigger('pushOkoForRecommendations', timeStamp, query, collection.itemNotInStock)
        }, SEARCH_RECOMENDATIONS_LOAD_LATENCY)
      }
    }
    // удаляем пустые элементы
    keys(filter).forEach(propertyNum => {
      if (!filter[propertyNum]) {
        delete filter[propertyNum]
      }
    })
    this.catalogInitFlag = false
    this.catalogParamsFlag = false
    // Если нет примененных фильтров не нужно отправлять в око
    if (!isEmpty(filter)) {
      const arraySid = collection.models.map(item => {
        return item.get('sid')
      })
      const activeSearchQueries = values(activeSearchFilterState).join(', ')
      if (activeSearchQueries.length) {
        filter.custom_str = activeSearchQueries
      }
      filter.n = 'filter'
      filter['items-found'] = collection.state.totalRecords
      filter.sid = arraySid
      this.pushData(filter)
    }
  }

  /**
   * Реакция на изменения параметров в каталоге
   */
  eventCatalogParams () {
    this.catalogParamsFlag = true
  }

  /**
   * Товар просмотрен
   *
   * @param {Item|WishItem|CartItem} item
   */
  eventViewItem (item) {
    if (item instanceof CartItem) {
      this.viewedItemList.push(item.get('item_sid'))
    } else {
      this.viewedItemList.push(item.get('sid'))
    }
  }

  /**
   * Отправляет данные в Oko.
   *
   * @param {Object} data
   */
  pushData (data) {
    okoPush(data)
  }
}
